import { render, staticRenderFns } from "./HeadacheListView.vue?vue&type=template&id=3e85a5ca&scoped=true&"
import script from "./HeadacheListView.vue?vue&type=script&lang=js&"
export * from "./HeadacheListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85a5ca",
  null
  
)

export default component.exports